export default [
    'E',
    'G',
    'B',
    'Ej',
    'Dev',
    'Cl',
    'V',
    'C4',
    'Bedr',
    '18',
    '16',
    '14'
];
